import axios from '@/plugins/axios'

export default {
  index (parent) {
    return axios.get(`/inspector/product-categories?parent=${parent}`)
  },
}
